<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Client Information</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <proof-form
          :data="data"
          @onConvert="setImage"
          @onInput="formInputChange"
        ></proof-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>

      <v-btn
        :disabled="disallowSubmit"
        color="blue darken-1"
        text
        @click="generatePdf"
        >Generate PDF</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import FormErrors from '../../../components/FormErrors.vue'
import { axios } from '../../../utils'
import ProofForm from './ProofForm'
import jspdf from 'jspdf'
import moment from 'moment'
import img from '../../../utils/base64_format'

export default {
  name: 'ProofDialog',
  data() {
    return {
      data: {
        client_name: '',
        business_name: '',
        unit: '',
        street: '',
        suburb: '',
        category: '',
        size: '',
        area: '',
        consultant: ''
      },
      image64: null,
      loading: false,
      errors: [],
      disallowSubmit: true,
      artHeight: null,
      artWidth: null,
      picStartPoint: 0
    }
  },
  props: ['close', 'contracts', 'item'],
  components: {
    ProofForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      let sizeSet = {
        1: 'A',
        2: 'B',
        3: 'C',
        4: 'D'
      }
      axios
        .get(`api/admin/clients/client-proof/${this.item.id}`)
        .then(res => {
          console.log(res.data)
          let dataOne = res.data[0]
          this.data.client_name = dataOne.client.client_name
          // console.log('printing client_name', this.data.client_name);

          this.data.business_name = dataOne.client.business_name
          // console.log('printing business_name', this.data.business_name);

          this.data.unit = dataOne.client.unit
          // console.log('priting unit', this.data.unit);

          this.data.street = dataOne.client.street
          // console.log('printing street', this.data.street);

          this.data.suburb = dataOne.suburbs[0].name
          // console.log('printing suburb', this.data.suburb);

          this.data.category = dataOne.categories[0].name
          // console.log('printing category', this.data.category);

          this.data.area = dataOne.regions[0].name

          this.data.size = sizeSet[dataOne.size]
          // console.log('printing size', dataOne.size);

          this.data.consultant = `${dataOne.employee.first_name} ${dataOne.employee.last_name}`
          // console.log('printing sp', this.data.consultant);

          this.loading = false
        })
        .catch(err => console.log(err))
    }
  },
  methods: {
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        client_name: '',
        business_name: '',
        unit: '',
        street: '',
        suburb: '',
        category: '',
        size: '',
        area: '',
        consultant: ''
      }
    },
    formInputChange(value) {
      this.data = Object.assign({}, this.data, value)
    },
    setImage(value) {
      this.image64 = value.img
      this.disallowSubmit = value.submit
      let image = new Image()
      image.src = this.image64
      image.onload = () => {
        // console.log(image.height, ', ', image.width);

        let maxHeight = 100.0
        let maxWidth = 105.0
        let ratio = 1.0
        let width = image.width
        let height = image.height
        if (height > maxHeight && width > maxWidth) {
          ratio = maxWidth / width
          this.artHeight = height * ratio
          this.artWidth = maxWidth
          if (this.artHeight > maxHeight) {
            ratio = maxHeight / height
            this.artWidth = width * ratio
            this.artHeight = maxHeight
            this.picStartPoint = 105 - this.artWidth / 2
          }
          this.picStartPoint = 105 - this.artWidth / 2
          // console.log(this.artHeight)
        } else if (height > maxHeight) {
          ratio = maxHeight / height
          this.artWidth = width * ratio
          this.artHeight = maxHeight
          this.picStartPoint = 105 - this.artWidth / 2
          // console.log(this.artHeight)
        } else if (width > maxWidth) {
          ratio = maxWidth / width
          this.artHeight = height * ratio
          this.artWidth = maxWidth
          this.picStartPoint = 105 - this.artWidth / 2
          // console.log(this.artWidth)
        }
      }
    },
    generatePdf() {
      let document = new jspdf()
      let date = moment().format('MMM Do YYYY')
      let image = img

      document.addImage(image, 'JPEG', 0, 0, 210, 300)
      document.addImage(
        this.image64,
        'JPEG',
        this.picStartPoint,
        75,
        this.artWidth,
        this.artHeight
      )

      document.setTextColor('#545454')
      //  document.setTextColor('#343435');
      document.setFont('Courier', '')
      document.setFontSize(12)
      document.text(date, 166, 24) //Date the verification was sent at

      document.setFont('Courier', '')
      document.setFontSize(11.3)
      document.text(this.data.client_name, 31, 201.2) //Business owner

      document.setFontSize(11.3)
      document.text('Standard', 30, 206.3) //Type of business

      document.setFontSize(11.3)
      document.text(this.data.size, 29, 211.6) //Size [A, B, C, D]

      document.setFontSize(11.3)
      document.text(this.data.area, 30, 216.6) //area at which business is signed up for

      document.setFontSize(11.3)
      if (this.data.category.length < 30) {
        document.text(this.data.category, 33.3, 221.5) //Category of busines
      } else {
        document.text(this.data.category, 21, 225.5)
      }

      document.setFontSize(11.3)
      document.text(this.data.consultant, 35.6, 240) //Consultant name

      document.setFont('Courier', '')
      document.setFontSize(14)
      document.text(this.data.business_name, 24, 260) //Someinfo for ad

      document.setFont('Courier', '')
      document.setFontSize(10.8)
      document.text(this.data.unit + ' ' + this.data.street, 24, 265) //some address maybe
      document.setFontSize(10)
      document.text(this.data.suburb, 24, 269) //some address maybe

      // document.setFont('Courier', 'Bold');
      // document.setFontSize(11.3);
      // document.text('Odessy Cleaning', 145, 258);//Print Name

      // document.setFont('Courier', 'Bold');
      // document.setFontSize(11.3);
      // document.text('some sign', 145, 267);//signature

      // document.setFont('Courier', 'Bold');
      // document.setFontSize(11.3);
      // document.text('20/12/2021', 145, 277);//Date of approval

      document.save('Proof.pdf')
      this._close()
    }
  }
}
</script>

<style lang="scss" scoped></style>
